export const RATE_SOURCE_TYPE = {
	DEFAULT: 1,
	OVERRIDDEN: 2
};
